import  { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
} from "../../../../components/commons";
import Select from "react-select";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  currentYear,
  formatDate,
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import {
  emailAllUserAttendanceReportAction,
  getAllUserAttendanceReportAction,
  getSingleAttendanceDetailAction,
  resetAllUserAttendanceReportList,
  resetAttendanceReportListCount,
  resetSingleAttendanceDetail,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
} from "../../../../redux/timeSheet";
import { resetSession } from "../../../../redux/auth";
import {
  EmailAllUserTimesheetReportPayloadType,
  GetAllUserAttendanceReportDataPayloadType,
} from "../../../../commonTypes/timeSheetTypes";
import AllUserAttendanceReportCalenderView from "../../../../components/TimeSheetReports/Attendance/AllUserAttendanceReportCalenderView";
import SingleAttendanceModal from "../../../../components/TimeSheetReports/Attendance/SingleAttendanceModal";
import { GetAttendanceTimePayloadType } from "../../../../commonTypes/authTypes";
import moment from "moment";
import {
  EmptyTimeSheetReportList,
} from "../../../../assets/images";
import EmailAllUserReportPopup from "../../../../components/TimeSheetReports/EmailAllUserReportPopup";
import toast, { Toaster } from "react-hot-toast";
import { SelectOptionType } from "../../../../redux/scheduling/schedulingTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  GetHolidayCalenderPayloadType,
  GetUsersDepartmentPayloadType,
} from "../../../../commonTypes/masterDataTypes";
import {
  getMasterDataHolidayCalenderAction,
  getMasterDataUsersDepartmentAction,
} from "../../../../redux/masterData";
import { DepartmentListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { GetMySpacePeopleOnLeavePayloadType } from "../../../../commonTypes/mySpaceType";
import { getPeopleOnLeaveAction } from "../../../../redux/mySpace";
import { PeopleOnLeaveListType } from "../../../../redux/mySpace/mySpaceTypes";
import { HolidayCalenderListType } from "../../../../redux/masterData/masterTypes";
 
type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  allUserAttendanceList: any;
  singleAttendanceDetail: any;
  totalCount: number;
  singleFetching: boolean;
  userDepartmentList: DepartmentListType[] | [];
  usersDepartmentFetching: boolean;
  totalDepartmentCount: number;
  usersEmailDepartmentFetching: boolean;
  peopleOnLeaveFetching: boolean;
  peopleOnLeaveData: PeopleOnLeaveListType[] | [];
  holidayCalenderList: HolidayCalenderListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetTimeSheetError: () => void;
  dispatchResetTimeSheetSuccess: () => void;
  dispatchResetTimeSheetMessage: () => void;
  dispatchResetTimeSheetStatusCode: () => void;
  dispatchEmailAttendanceTimesheetReportAction: (
    data: EmailAllUserTimesheetReportPayloadType
  ) => void;
  dispatchResetAllUserAttendanceReportList: () => void;
  dispatchGetAllUserAttendanceReportList: (
    data: GetAllUserAttendanceReportDataPayloadType
  ) => void;
  dispatchGetSingleAttendanceDetailAction: (
    data: GetAttendanceTimePayloadType
  ) => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchResetAttendenceSingleDetailData: () => void;
  dispatchResetAttendanceReportListCount: () => void;
  dispatchGetPeopleOnLeaveAction: (
    data: GetMySpacePeopleOnLeavePayloadType
  ) => void;
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
};
const AllUserAttendanceReport = ({
  token,
  error,
  statusCode,
  success,
  message,
  fetching,
  totalCount,
  singleFetching,
  allUserAttendanceList,
  singleAttendanceDetail,
  userDepartmentList,
  usersEmailDepartmentFetching,
  usersDepartmentFetching,
  totalDepartmentCount,
  peopleOnLeaveData,
  peopleOnLeaveFetching,
  holidayCalenderList,
  dispatchResetSession,
  dispatchResetTimeSheetSuccess,
  dispatchResetTimeSheetError,
  dispatchResetTimeSheetMessage,
  dispatchResetTimeSheetStatusCode,
  dispatchResetAllUserAttendanceReportList,
  dispatchGetAllUserAttendanceReportList,
  dispatchGetSingleAttendanceDetailAction,
  dispatchResetAttendenceSingleDetailData,
  dispatchEmailAttendanceTimesheetReportAction,
  dispatchResetAttendanceReportListCount,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchGetPeopleOnLeaveAction,
  dispatchGetMasterDataHolidayCalenderAction,
}: AppProps) => {
  const type = "allUser";
  const { start, end } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [showData, setShowData] = useState(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [date, setDate] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [limit, setLimit] = useState(20);
  const [usersDepartmentOffset, setUsersDepartmentOffset] = useState<number>(0);
  const [usersEmailDepartmentOffset, setUsersEmailDepartmentOffset] =
    useState<number>(0);
  const [usersDepartmentText, setUsersDepartmentText] = useState<string>("");
  const [usersEmailDepartmentText, setUsersEmailDepartmentText] =
    useState<string>("");
 
  const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
    []
  );
 
  const [attendance, setAttendance] = useState<any>([]);
  const [finalAllUserAttendanceList, setFinalAllUserAttendanceList] =
    useState<any>([]);
  const [department, setDepartment] = useState<SelectOptionType>({
    label: "Select Department",
    value: null,
  });
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  // Email All User Timesheet Report states
  const [emailReportStartDate, setEmailReportStartDate] = useState<string>("");
  const [emailReportEndDate, setEmailReportEndDate] = useState<string>("");
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [emailDepartment, setEmailDepartment] = useState<SelectOptionType>({
    label: "Select Department",
    value: null,
  });
  useEffect(() => {
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetError();
    dispatchResetTimeSheetMessage();
    dispatchResetTimeSheetStatusCode();
    dispatchResetAllUserAttendanceReportList();
    dispatchResetAttendanceReportListCount();
  }, []);

  useEffect(() => {
   let finalData= allUserAttendanceList?.map((item:any)=>{
        let flag=false;
        let date:any=""
        let newData =item?.result?.map((single:any)=>{
          let found= holidayCalenderList?.find((itemDate:any)=>formatDate(itemDate?.date)===formatDate(single?.date))

          if(found && single?.time_difference!=null){
            return {...single,is_leave: "holiday"}
          }
          else{
            return {...single}
          }
        })
 
        holidayCalenderList?.map((finNew:any)=>{
          let found= newData?.find((itemDate:any)=>formatDate(itemDate?.date)===formatDate(finNew?.date))
          if(!found){
             newData?.push({
              date: finNew?.date?.split(" ")[0],
            day: "Wednesday",
            total_hours: null,
            time_difference: null,
            start_time: "02:50PM",
            end_time: "02:51PM",
            start_location: "",
            end_location: "",
            is_leave: "holiday",
            description: finNew?.description,
            })
          }
        })
 
      return {...item,result:newData}
    })
    setFinalAllUserAttendanceList([...finalData])
 
  }, [holidayCalenderList, allUserAttendanceList]);
 
 
  //Department List
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });
 
    if (
      (usersDepartmentOffset > 0 || usersEmailDepartmentOffset > 0) &&
      finalUsersDepartmentList?.length &&
      finalDepartmentListData?.length
    ) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else if (finalDepartmentListData?.length) {
      setFinalUsersDepartmentList([...finalDepartmentListData]);
    } else {
      setFinalUsersDepartmentList([]);
    }
  }, [userDepartmentList]);
 
  useEffect(() => {
    if (token && totalDepartmentCount) {
      if (usersDepartmentOffset <= +totalDepartmentCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersDepartmentOffset]);
 
  useEffect(() => {
    if (token && totalDepartmentCount) {
      if (usersEmailDepartmentOffset <= +totalDepartmentCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersEmailDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersEmailDepartmentOffset]);
 
  useDebounce(
    () => {
      if (usersDepartmentText) {
        fetchUsersDepartmentNewData("userDepartment");
      } else {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersDepartmentText]
  );
 
  useDebounce(
    () => {
      if (usersEmailDepartmentText) {
        fetchUsersDepartmentNewData("email");
      } else {
        const finalData = {
          token,
          status: 1,
          offset: usersEmailDepartmentOffset,
          limit: limit,
          searchValue: usersEmailDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersEmailDepartmentText]
  );
 
  const fetchUsersDepartmentNewData = (type: string) => {
    const finalData = {
      token,
      status: 1,
      offset:
        type === "email" ? usersEmailDepartmentOffset : usersDepartmentOffset,
      limit: limit,
      searchValue:
        type === "email" ? usersEmailDepartmentText : usersDepartmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };
 
  const checkUsersDepartmentBottom = () => {
    setUsersDepartmentOffset((prv: any) => prv + limit);
  };
 
  const checkUsersEmailDepartmentBottom = () => {
    setUsersEmailDepartmentOffset((prv: any) => prv + limit);
  };
 
  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
 
  const handleEmailReportStartDate = (date: any) => {
    setEmailReportStartDate(date);
  };
 
  const handleResetEmailEndDate = () => {
    setEmailReportEndDate("");
  };
 
  const handleEmailReportEndDate = (date: any) => {
    setEmailReportEndDate(date);
  };
 
  // Trigger Email for All User Attendance Rerport
  const handleEmailAllUserAttendanceReportData = () => {
    if (token && emailReportStartDate && emailReportEndDate) {
      let finalData: EmailAllUserTimesheetReportPayloadType = {
        start_date: formatDate(emailReportStartDate),
        end_date: formatDate(emailReportEndDate),
        token,
        department:
          emailDepartment?.label === "Select Department" ||
          emailDepartment?.label === "All Departments"
            ? ""
            : emailDepartment?.label,
      };
 
      dispatchEmailAttendanceTimesheetReportAction(finalData);
    }
  };
 
  const toggleModal = (info?: any) => {
    let leaveIcon = info?.event?.extendedProps?.leave;
    let holidayIcon = info?.event?._def?.extendedProps?.holiday;

    setDate("");
    setName("");
    dispatchResetAttendenceSingleDetailData();
    if (!isModalVisible) {
      let finalDate = moment(info?.event?._def?.extendedProps?.date)?.format(
        "DD-MM-YYYY"
      );
      setDate(finalDate);
      setName(info?.event?._def?.extendedProps?.userName);
      setLocation(info?.event?._def?.extendedProps?.location);
      const finalData = {
        token,
        date: moment(info?.event?._def?.extendedProps?.date)?.format(
          "DD-MM-YYYY"
        ),
        user_id: info?.event?._def?.extendedProps?.userId,
      };
      dispatchGetSingleAttendanceDetailAction(finalData);
    }
    if(!leaveIcon  && !holidayIcon){

      setIsModalVisible((prev: boolean) => !prev);
    }
  };
 
  const handleDepartmentChange = (department: SelectOptionType) => {
    setDepartment(department);
  };
 
  const handleEmailDepartmentChange = (department: SelectOptionType) => {
    setEmailDepartment(department);
  };
 
  const handleSubmit = () => {
    setShowData(true);
    dispatchResetAttendanceReportListCount();
    dispatchResetAllUserAttendanceReportList();
    if (token) {
      let finalData = {
        token,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        department:
          department?.label === "Select Department" ||
          department?.label === "All Departments"
            ? ""
            : department?.label,
      };
      dispatchGetAllUserAttendanceReportList(finalData);
      let data: GetHolidayCalenderPayloadType = {
        token,
        start_date: `01-01-${currentYear()}`,
        end_date: `31-12-${currentYear()}`,
        country: "India",
        sort_by: "date",
        sort_by_value: "desc",
      };
      dispatchGetMasterDataHolidayCalenderAction(data);
 
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };
 
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetTimeSheetSuccess();
              dispatchResetTimeSheetError();
              dispatchResetTimeSheetMessage();
              dispatchResetTimeSheetStatusCode();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetSuccess();
              dispatchResetTimeSheetError();
              dispatchResetTimeSheetMessage();
              dispatchResetTimeSheetStatusCode();
            }}
          />
        );
      }
    } else if (success === 1) {
      if (message && message === "Email has been sent successfully!") {
        toast.success(
          "Requested Attendance Report will be mailed to you in 20-minutes!",
          {
            duration: 3000,
          }
        );
        dispatchResetTimeSheetMessage();
        dispatchResetTimeSheetSuccess();
      }
    }
 
    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="All User's Attendance" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">
                All User's Attendance List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } reports found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex"></div>
          </div>
          {/*  */}
          <div>
            <div
              className="d-flex align-items-start"
              style={{ justifyContent: "space-between" }}
            >
              <div className="d-flex">
                <div className="form-group ml-3">
                  <label className="mb-1">
                    Date <span className="color-red">*</span>
                  </label>
                  <div>
                    <ReportsDateSelect
                      setToggle={setToggle}
                      toggle={toggle}
                      startDate={startDate ? startDate : ""}
                      endDate={endDate ? endDate : ""}
                      handleStartDateChange={handleStartDateChange}
                      handleEndDateChange={handleEndDateChange}
                      type={"schedulingReport"}
                      clearEndDate={true}
                      minDate={"2023-12-01"}
                    />
                  </div>
                </div>
                <div
                  style={{ maxWidth: "240px" }}
                  className="col-md-6 d-flex flex-column"
                >
                  <label htmlFor="department">Department</label>
                  <div className="mt-1">
                    <Select
                      options={
                        finalUsersDepartmentList?.length > 0
                          ? [
                              { label: "All Departments", value: null },
                              ...finalUsersDepartmentList,
                            ]
                          : []
                      }
                      value={department}
                      onChange={(department: any) =>
                        handleDepartmentChange(department)
                      }
                      isSearchable={true}
                      isLoading={showDropdown ? false : usersDepartmentFetching}
                      onMenuClose={() => setUsersDepartmentOffset?.(0)}
                      onMenuScrollToBottom={checkUsersDepartmentBottom}
                      onInputChange={(e) => {
                        setUsersDepartmentText?.(e);
                        setUsersDepartmentOffset?.(0);
                      }}
                    />
                  </div>
                </div>
                <div className="ml-3" style={{ marginTop: "29px" }}>
                  <button
                    className="btn btn-primary pl-3 pb-2"
                    disabled={!startDate?.length || !endDate?.length}
                    onClick={handleSubmit}
                  >
                    Apply
                  </button>
                </div>
              </div>
 
              <div
                className="mt-1"
                style={{
                  marginRight: "13.2px",
                  paddingTop: "21px",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <EmailAllUserReportPopup
                  header={"Email Attendance Report"}
                  type={"AllUserAttendanceReport"}
                  showDropdown={showDropdown}
                  setShowDropdown={setShowDropdown}
                  setEmailDepartment={setEmailDepartment}
                  emailReportStartDate={emailReportStartDate}
                  emailReportEndDate={emailReportEndDate}
                  handleResetEmailEndDate={handleResetEmailEndDate}
                  handleEmailReportStartDate={handleEmailReportStartDate}
                  handleEmailReportEndDate={handleEmailReportEndDate}
                  handleEmailAllUserTimesheetReportData={
                    handleEmailAllUserAttendanceReportData
                  }
                  finalUsersDepartmentList={
                    finalUsersDepartmentList?.length > 0
                      ? [
                          { label: "All Departments", value: null },
                          ...finalUsersDepartmentList,
                        ]
                      : []
                  }
                  emailDepartment={emailDepartment}
                  handleEmailDepartmentChange={handleEmailDepartmentChange}
                  usersDepartmentFetching={usersEmailDepartmentFetching}
                  setUsersDepartmentOffset={setUsersDepartmentOffset}
                  checkUsersDepartmentBottom={checkUsersEmailDepartmentBottom}
                  setUsersEmailDepartmentText={setUsersEmailDepartmentText}
                />
              </div>
            </div>
          </div>
          {!fetching && (!showData || allUserAttendanceList?.length === 0) ? (
            <div className="pb-4 pl-0 pr-0 pt-4">
              <EmptyListPage
                title="No Attendance List Found!"
                imageWidth="30%"
                image={EmptyTimeSheetReportList}
                showAddButton={false}
              />
            </div>
          ) : (
            <div>
              <>
              
              </>
              <AllUserAttendanceReportCalenderView
                data={finalAllUserAttendanceList}
                fetching={fetching}
                totalCount={totalCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
                setIsModalVisible={setIsModalVisible}
                toggleModal={toggleModal}
                peopleOnLeaveData={peopleOnLeaveData}
                holidayCalenderList={holidayCalenderList}
              />
            </div>
          )}
 
          {isModalVisible ? (
            <SingleAttendanceModal
              toggleModal={toggleModal}
              isOpen={isModalVisible}
              attendenceData={singleAttendanceDetail?.response}
              totalAttendanceHours={singleAttendanceDetail?.total_time}
              fetching={singleFetching}
              date={date}
              location={location}
              name={name}
              type={"allUser"}
            />
          ) : null}
        </div>
      </div>
 
      <Toaster
        toastOptions={{
          style: {
            textAlign: "center",
          },
        }}
      />
 
      {handleErrorModal()}
    </>
  );
};
 
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  totalCount: state.timeSheet.reportListCount,
  allUserAttendanceList: state.timeSheet.allUserAttendanceReportList,
  singleAttendanceDetail: state.timeSheet.singleAttendanceDetail,
  singleFetching: state.timeSheet.singleFetching,
  userDepartmentList: state.masterData.userDepartmentList,
  totalDepartmentCount: state.masterData.userDepartmentTotalCount,
  usersDepartmentFetching: state.masterData.fetching,
  usersEmailDepartmentFetching: state.masterData.fetching,
  peopleOnLeaveFetching: state.mySpace.peopleOnLeaveFetching,
  peopleOnLeaveData: state.mySpace.peopleOnLeaveData,
  holidayCalenderList: state.masterData.holidayCalenderList,
  holidayFetching: state.masterData.fetching,
});
 
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetStatusCode: () => dispatch(resetTimeSheetStatusCode()),
  dispatchGetAllUserAttendanceReportList: (
    data: GetAllUserAttendanceReportDataPayloadType
  ) => dispatch(getAllUserAttendanceReportAction(data)),
  dispatchResetAllUserAttendanceReportList: () =>
    dispatch(resetAllUserAttendanceReportList()),
  dispatchGetSingleAttendanceDetailAction: (
    data: GetAttendanceTimePayloadType
  ) => dispatch(getSingleAttendanceDetailAction(data)),
  dispatchResetAttendenceSingleDetailData: () =>
    dispatch(resetSingleAttendanceDetail()),
  dispatchEmailAttendanceTimesheetReportAction: (
    data: EmailAllUserTimesheetReportPayloadType
  ) => dispatch(emailAllUserAttendanceReportAction(data)),
  dispatchResetAttendanceReportListCount: () =>
    dispatch(resetAttendanceReportListCount()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchGetPeopleOnLeaveAction: (data: GetMySpacePeopleOnLeavePayloadType) =>
    dispatch(getPeopleOnLeaveAction(data)),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
});
 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUserAttendanceReport);